import React from 'react';
import SamuraiGame from '../SamuraiGame';

const Click6Samurai = () => {
    return <SamuraiGame initialDrillIndex={8} />;
};

export default Click6Samurai;
